import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import it from './locales/it.json';
import en from './locales/en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      it: { translation: it },
      en: { translation: en },
    },
    fallbackLng: 'it',
    supportedLngs: ['it', 'en'],
    detection: {
      // Order of detection: localStorage preference first, then browser language
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'happy_lang',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

// If browser language is not Italian, switch to English (unless user manually chose)
if (!localStorage.getItem('happy_lang')) {
  const browserLang = navigator.language || navigator.userLanguage || 'it';
  if (!browserLang.toLowerCase().startsWith('it')) {
    i18n.changeLanguage('en');
  } else {
    i18n.changeLanguage('it');
  }
}

export default i18n;
